/* Magic-menuen: Sealed/Singles-vælger (desktop-panel og mobil-akkordeon). */
(function () {
  function init() {
    document.querySelectorAll('[data-mtg]').forEach(function (rod) {
      if (rod.__mtwMtg) return;
      rod.__mtwMtg = 1;
      var knapper = rod.querySelectorAll('[data-mtg-mode]');
      knapper.forEach(function (knap) {
        knap.addEventListener('click', function () {
          var mode = knap.getAttribute('data-mtg-mode');
          knapper.forEach(function (k) { k.setAttribute('aria-pressed', k === knap ? 'true' : 'false'); });
          rod.querySelectorAll('[data-mtg-pane]').forEach(function (p) {
            p.hidden = p.getAttribute('data-mtg-pane') !== mode;
          });
          // mtw-mega-nav.js skjuler ruder i begge kroppe, så aktivér den valgte krops første fane
          var vist = rod.querySelector('[data-mtg-pane="' + mode + '"]');
          var forste = vist && vist.querySelector('[data-mtw-mn-tab]');
          if (forste) forste.click();
        });
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Mobilmenuens Magic-akkordeon kommer først, når menuen er hentet (mtw-mega-nav.js).
  document.addEventListener('mtw:mobilmenu-klar', init);
})();
